<template>
    <div>
        <v-modal :showPicture="false" ref="modalDanger" id="alert_danger_modal" :class="tipo" size="30" :titulo="titleModal" :ico="icoModal">
            <div slot="body">
                <p v-html="text"></p>
            </div>
            <div v-if="eFuncao" slot="buttons" class="col">
                <button v-if="$root.alert.closeButton" class="button btn rounded-0 button-dark btn-dark" @click="close">Fechar</button>
                <button class="button btn rounded-0 button-dark btn-dark" @click="executaFuncao">{{ textBotao }}</button>
            </div>
        </v-modal>

        <transition v-if="text" name="slide-fade-slow" mode="out-in">
            <section class="container mb-2">
                <div class="alert fade show" :class="tipo">
                    <span v-html="text"></span>
                    <button type="button" class="close" @click="$refs.modalDanger.close()"><span aria-hidden="true">&times;</span></button>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>
  export default {
    data: function () {
      return {
        tipos: {
          primary:      'alert-primary',
          secondary:    'alert-secondary',
          success:      'alert-success',
          danger:       'alert-danger',
          warning:      'alert-warning',
          info:         'alert-info',
          light:        'alert-light',
          dark:         'alert-dark',
        },
        text: null,
        tipo: null,
        funcao: null,
        textBotao: null,
        titleModal: null,
        icoModal: null,
      }
    },
    watch: {
      '$root.alert.texto': function () {
        this.init()
      }
    },
    computed: {
      eFuncao() {
          return _.isFunction(this.funcao)
      },
    },
    methods: {
      close() {
        this.$root.setAlert()
        this.$refs.modalDanger.close()
        this.init()
      },
      init() {
        this.text = this.$root.alert.texto
        this.funcao = this.$root.alert.function
        this.textBotao = this.$root.alert.textBotao
        this.tipo = this.tipos.hasOwnProperty(this.$root.alert.tipo) ? this.tipos[this.$root.alert.tipo] : this.tipos.primary
        if(this.$root.alert.texto && this.$refs.modalDanger) {
          this.titleModal = this.tipo == 'alert-danger' ? 'Ocorreu um erro' : 'Ação realizada com sucesso'
          this.icoModal = this.tipo == 'alert-danger' ? 'ion-alert-circled' : 'ion-checkmark'
          this.$refs.modalDanger.show()
        }
      },
      executaFuncao() {
          if(this.eFuncao){
              this.funcao()
              this.close()
          }
      },
    },
    created() {
      this.init()
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/includes/Alert.vue